// New custom hook file, e.g., useMoveOrDeleteEmailHook.ts

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { moveOrDeleteEmail } from "../helpers/AxiosInstance"; // Adjust path to your AxiosInstance file

interface IUseMoveOrDeleteEmailHook {
  queryKey: string[];
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
}

const useMoveOrDeleteEmailHook = (props: IUseMoveOrDeleteEmailHook) => {
  const { queryKey, showSuccessToast = true, showErrorToast = true } = props;
  const queryClient = useQueryClient();

  const {
    isPending: isMoveOrDeleteLoading,
    mutateAsync,
    isSuccess: isMoveOrDeleteSuccess,
    data: moveOrDeleteData,
    isError: isMoveOrDeleteError,
  } = useMutation({
    mutationFn: moveOrDeleteEmail,
    onSuccess: async (data) => { 
      if (data?.status === 201 || data?.status === 200) {
        if (showSuccessToast) {
         toast.success(data?.data?.message ?? "Mail Deleted Successfully");
        }
      } else {
        if (showErrorToast) {
          if (data?.data?.non_field_errors) {
            toast.error(data?.data?.non_field_errors[0]);
          } else {
            toast.error(data?.data?.message ?? "Something went wrong");
          }
        }
      }
    },
    onError: (error) => {
      if (showErrorToast) {
        toast.error("Error");
      }
    },
    onSettled: async () => {
      queryClient.invalidateQueries({
        queryKey: queryKey,
        refetchType: "active",
      });
    },
  });

  return {
    isMoveOrDeleteLoading,
    mutateAsync,
    isMoveOrDeleteSuccess,
    moveOrDeleteData,
    isMoveOrDeleteError,
  };
};

export default useMoveOrDeleteEmailHook;